import {SelectInput} from 'react-admin';

const SelectInputMod = props => {
    return (<SelectInput {...props} />);
};

export default SelectInputMod;